import { render, staticRenderFns } from "./DatasourcesAssignment.vue?vue&type=template&id=0d468ace&lang=pug"
import script from "./DatasourcesAssignment.vue?vue&type=script&lang=js"
export * from "./DatasourcesAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d468ace')) {
      api.createRecord('0d468ace', component.options)
    } else {
      api.reload('0d468ace', component.options)
    }
    module.hot.accept("./DatasourcesAssignment.vue?vue&type=template&id=0d468ace&lang=pug", function () {
      api.rerender('0d468ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/DatasourcesAssignment.vue"
export default component.exports